import { render, staticRenderFns } from "./PhotosCards.vue?vue&type=template&id=398baab0"
import script from "./PhotosCards.vue?vue&type=script&lang=js"
export * from "./PhotosCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports